<template>
  <div>
    <b-modal id="siteConfigurationFormModal" size="lg" @shown="resetFormModal">

      <template v-slot:modal-title>
        <h4 style="margin-bottom: 0px;">
          Integrated Site '{{ siteConfiguration.domain }}' <br/>
        </h4>
        <small> By user '{{ siteConfiguration.user.email }}' </small>
      </template>

      <form>
        <ShowErrors
          :errorMessages="errorMessages"
        />

        <b-alert show>
          The following fields should be completed with CNAME record information
          provided by CloudFront SSL certificate for domain '{{ siteConfiguration.domain }}'
        </b-alert>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="dns_cname_record_name">CNAME Record Name</label>
              <input type="text" v-model="dnsCnameRecordName"
                name="dns_cname_record_name" class="form-control form-control-lg"
                v-validate="'required'" data-vv-as="Name"/>
              <span v-show="errors.has('dns_cname_record_name')" class="input-error">
                {{ errors.first('dns_cname_record_name') }}
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="dns_cname_record_value">CNAME Record Value</label>
              <input type="text" v-model="dnsCnameRecordValue"
                name="dns_cname_record_value" class="form-control form-control-lg"
                v-validate="'required'" data-vv-as="Value"/>
              <span v-show="errors.has('dns_cname_record_value')" class="input-error">
                {{ errors.first('dns_cname_record_value') }}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <b-form-checkbox v-model="sendDnsConfigurationEmail" size="lg" switch>
              Send email with DNS configuration steps
            </b-form-checkbox>
          </div>
        </div>
      </form>

      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="validate()">
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ShowErrors from '../../../common/ShowErrors'

export default {
  name: 'SiteConfigurationFormModal',
  props: {
    siteConfiguration: {
      required: true
    }
  },
  components: {
    ShowErrors
  },
  data: function () {
    return {
      errorMessages: [],
      dnsCnameRecordName: null,
      dnsCnameRecordValue: null,
      sendDnsConfigurationEmail: true
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (self.sendDnsConfigurationEmail) {
            self.$swal({
              title: 'Confirm save and send email with DNS configuration steps?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Confirm!'
            }).then((result) => {
              if (result.value) {
                self.updateSiteConfiguration()
              }
            })
          } else {
            self.updateSiteConfiguration()
          }
        }
      })
    },
    updateSiteConfiguration () {
      var self = this
      var scObject = {
        site_configuration: {
          dns_cname_record_name: this.dnsCnameRecordName,
          dns_cname_record_value: this.dnsCnameRecordValue
        },
        send_dns_configuration_email: this.sendDnsConfigurationEmail
      }
      this.loader = this.$loading.show()

      this.$http.put('/site_configurations/' + this.siteConfiguration.id + '/update_dns_configuration', scObject)
        .then(function (response) {
          self.siteConfiguration['dns_cname_record_name'] = response.data.dns_cname_record_name
          self.siteConfiguration['dns_cname_record_value'] = response.data.dns_cname_record_value
          self.siteConfiguration['dns_config_email_sent'] = response.data.dns_config_email_sent

          self.$bvModal.hide('siteConfigurationFormModal')

          self.$swal({
            title: 'DNS settings updated!',
            type: 'success'
          })
        }).catch(function (error) {
          if (error) {
            self.$swal({
              title: 'Error updating DNS Settings!',
              type: 'error'
            })

            var errorMsgs = error.response.data.message || error.response.data.error
            self.errorMessages.push(errorMsgs)
          }
        }).finally(function () {
          self.loader.hide()
        })
    },
    resetFormModal () {
      this.dnsCnameRecordName = this.siteConfiguration.dns_cname_record_name
      this.dnsCnameRecordValue = this.siteConfiguration.dns_cname_record_value
      this.sendDnsConfigurationEmail = true
    }
  }
}
</script>
